<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<h1 class="title" id="heading_id_2">TEAMWORK IS AN INDIVIDUAL SKILL</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?2f69ee65